import { Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const services = [
  { n: "01", title: "Load Searching", body: "Freight opportunities curated to your equipment, location, lanes, and preferences — not whatever the board spits out." },
  { n: "02", title: "Rate Negotiation", body: "We communicate and negotiate on your behalf, within the parameters you establish for your business." },
  { n: "03", title: "Broker Communication", body: "Routine broker calls, load details, setup packets, and check-ins — handled with clear, professional coordination." },
  { n: "04", title: "Load Planning", body: "Loads and lanes identified around your schedule, home time, and operating preferences. Deadhead kept honest." },
  { n: "05", title: "Paperwork Support", body: "Rate confirmations and routine load documentation kept organized so nothing slips through the cracks." },
  { n: "06", title: "Weekly Summaries", body: "An organized overview of loads dispatched and the gross revenue behind them. You always know the numbers." },
];

export const Services = () => (
  <section id="services" className="py-28 sm:py-36 bg-[#101010] border-y border-white/10" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-neutral-500 mb-4">
            Operations — What We Do
          </p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-3xl sm:text-5xl lg:text-6xl">
            Keeping your
            <br />
            truck moving.
          </h2>
        </div>
        <p className="text-neutral-400 max-w-sm leading-relaxed">
          Practical dispatch support designed around the needs of independent carriers. Six operations. One purpose.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
        {services.map((s, i) => (
          <Reveal key={s.n} delay={(i % 3) * 0.1}>
            <div
              className="group relative border-r border-b border-white/10 p-8 sm:p-10 min-h-[260px] flex flex-col justify-between hover:bg-white/[0.04] transition-colors duration-500 overflow-hidden"
              data-testid={`service-card-${s.n}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-xs tracking-[0.3em] text-neutral-500 group-hover:text-white transition-colors duration-500">
                  / {s.n}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-neutral-600 opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-500"
                />
              </div>
              <div>
                <h3 className="font-display font-bold uppercase tracking-tight text-xl sm:text-2xl mb-3">
                  {s.title}
                </h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{s.body}</p>
              </div>
              <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-white group-hover:w-full transition-all duration-700 ease-out" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
